export default class Header {

  constructor(el) {
    this.el = el
    this.hamburger = el.querySelector('.hamburger')
    this.menu = el.querySelector('.header--menu')
    this.subPanel = el.querySelector('.header--menu-sub-panel')

    this.bindReserveLink()

    if (!this.hamburger) return

    this.bindHamburger()
    this.bindSubMenus()
    this.bindScroll()
    this.bindNavColor()
  }

  bindReserveLink() {
    const actions = this.el.querySelector('.header--actions')
    const sujet = actions?.dataset.sujetReservation
    if (!actions || !sujet) return

    actions.querySelectorAll('a.btn').forEach(link => {
      link.addEventListener('click', () => {
        sessionStorage.setItem('sujet_reservation', sujet)
      })
    })
  }

  bindSubMenus() {
    const items = this.el.querySelectorAll('.menu-item-has-children')

    if (window.matchMedia('(max-width: 991px)').matches) {
      this.bindSubMenusMobile(items)
    } else {
      this.bindSubMenusDesktop(items)
    }
  }

  bindSubMenusMobile(items) {
    const close = (except = null) => {
      items.forEach(item => {
        if (item === except) return
        const sub = item.querySelector('.sub-menu')
        item.classList.remove('is-open')
        if (sub) sub.style.height = '0'
      })
    }

    items.forEach(item => {
      const sub = item.querySelector('.sub-menu')
      if (!sub) return

      const link = item.querySelector('a')
      sub.style.height = '0'

      link.addEventListener('click', e => {
        e.preventDefault()
        const isOpen = item.classList.toggle('is-open')
        close(item)
        sub.style.height = isOpen ? sub.scrollHeight + 'px' : '0'
      })
    })

    document.addEventListener('click', e => {
      if (!e.target.closest('.menu-item-has-children')) close()
    })
  }

  bindSubMenusDesktop(items) {
    if (!this.subPanel) return

    let hideTimeout
    let currentItem = null

    const hide = () => {
      this.subPanel.classList.remove('is-visible')
      if (currentItem) currentItem.classList.remove('is-hovered')
      currentItem = null
    }

    items.forEach(item => {
      const sub = item.querySelector('.sub-menu')
      if (!sub) return

      item.addEventListener('mouseenter', () => {
        clearTimeout(hideTimeout)
        if (currentItem && currentItem !== item) currentItem.classList.remove('is-hovered')
        currentItem = item
        this.subPanel.innerHTML = sub.outerHTML
        const itemRect = item.getBoundingClientRect()
        const panelRect = this.subPanel.getBoundingClientRect()
        this.subPanel.style.paddingTop = (itemRect.top - panelRect.top) + 'px'
        this.subPanel.classList.add('is-visible')
        item.classList.add('is-hovered')
      })

      item.addEventListener('mouseleave', () => {
        hideTimeout = setTimeout(hide, 100)
      })
    })

    this.subPanel.addEventListener('mouseenter', () => clearTimeout(hideTimeout))
    this.subPanel.addEventListener('mouseleave', () => {
      hideTimeout = setTimeout(hide, 100)
    })
  }

  bindNavColor() {
    const darkSections = document.querySelectorAll('.colored--primary')
    if (!darkSections.length) return

    const nav = this.el.querySelector('.header--nav')

    const check = () => {
      const navBottom = nav.getBoundingClientRect().bottom
      let isDark = false
      darkSections.forEach(section => {
        const rect = section.getBoundingClientRect()
        if (rect.top <= navBottom && rect.bottom >= 0) isDark = true
      })
      this.el.classList.toggle('is-over-dark', isDark)
    }

    window.addEventListener('scroll', check, { passive: true })
    check()
  }

  bindScroll() {
    const onScroll = () => this.el.classList.toggle('is-scrolled', window.scrollY >= 50)
    window.addEventListener('scroll', onScroll, { passive: true })
    onScroll()
  }

  bindHamburger() {
    this.hamburger.addEventListener('click', () => {
      const menuHamburger = this.el.querySelector('.header--menu-hamburger')
      const isOpen = this.hamburger.classList.toggle('is-active')
      menuHamburger.classList.toggle('is-active')
      this.menu?.classList.toggle('is-full', isOpen)
      this.hamburger.setAttribute('aria-expanded', String(isOpen))
    })
  }

}
